import * as React from 'react';
import { navigate } from "gatsby";
import { useLocation } from "@reach/router";
import { Drawer } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TelegramIcon from '@mui/icons-material/Telegram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import logoImage from '/src/images/logo/logo.svg';
import { MenuContext } from '../../../context/MenuContext';
import { AuthContext } from '../../../context/AuthContext';
import { LoadingContext } from '../../../context/LoadingContext';
import { TELEGRAM_KANAL, WHATSAPP_KANAL, INSTAGRAM_HESABI } from '../../../consts/Kanallar';
import { PATH_ADMIN, PATH_REKLAM_STUDYOSU, PATH_KODLAR_ADMIN, PATH_ESLESTIRME_ADMIN, PATH_KATEGORI_ESLEME_ADMIN } from '../../../consts/RouterPaths';
import trendyolLogo from '/src/images/pazaryeri/trendyol-logo.svg';
import hepsiburadaLogo from '/src/images/pazaryeri/hepsiburada-logo.svg';
import amazonLogo from '/src/images/pazaryeri/amazon-logo.svg';
import mediamarktLogo from '/src/images/pazaryeri/mediamarkt-logo.svg';
import vatanLogo from '/src/images/pazaryeri/vatan-logo.svg';
import n11Logo from '/src/images/pazaryeri/n11-logo.svg';
import pazaramaLogo from '/src/images/pazaryeri/pazarama-logo.png';
import idefixLogo from '/src/images/pazaryeri/idefix-logo.svg';
import { girisOncesiniHatirla } from '../../uye/GirisPenceresi';
import "./headerPremium.css";

// Yeni mağaza buraya eklenir (header "Mağazalar" menüsü ve burger çekmece)
const MAGAZALAR = [
    { ad: "Trendyol", to: "/tdetails", logo: trendyolLogo, alt: "Tüm Trendyol indirimleri" },
    { ad: "Hepsiburada", to: "/hdetails", logo: hepsiburadaLogo, alt: "Tüm Hepsiburada indirimleri" },
    { ad: "Amazon", to: "/adetails", logo: amazonLogo, alt: "Tüm Amazon indirimleri" },
    { ad: "MediaMarkt", to: "/mmdetails", logo: mediamarktLogo, alt: "Tüm MediaMarkt indirimleri" },
    { ad: "Vatan Bilgisayar", to: "/vdetails", logo: vatanLogo, alt: "Tüm Vatan Bilgisayar indirimleri", sinif: "iu-logo-iri" },
    { ad: "n11", to: "/ndetails", logo: n11Logo, alt: "Tüm n11 indirimleri" },
    { ad: "Pazarama", to: "/pzdetails", logo: pazaramaLogo, alt: "Tüm Pazarama indirimleri" },
    { ad: "İdefix", to: "/ixdetails", logo: idefixLogo, alt: "Tüm İdefix indirimleri" },
];

const KANALLAR = [
    { ad: "WhatsApp", href: WHATSAPP_KANAL, Ikon: WhatsAppIcon, sinif: "iu-k-whatsapp" },
    { ad: "Telegram", href: TELEGRAM_KANAL, Ikon: TelegramIcon, sinif: "iu-k-telegram" },
    { ad: "Instagram", href: INSTAGRAM_HESABI, Ikon: InstagramIcon, sinif: "iu-k-instagram" },
];

/** Hamburger / kapat simgesi (çizgiler) — MUI ikonu yerine ince çizgi. */
const Cizgiler = ({ acik }) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true">
        {acik ? <><path d="M6 6l12 12" /><path d="M18 6L6 18" /></> : <><path d="M4 7h16" /><path d="M4 12h16" /><path d="M4 17h10" /></>}
    </svg>
);

const KisiSimgesi = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true">
        <circle cx="12" cy="8" r="4" /><path d="M4 20c1.5-3.5 4.5-5 8-5s6.5 1.5 8 5" />
    </svg>
);

/**
 * Üst bar: ince marka şeridi; logo + mağaza bağlantıları + kanal simgeleri + hesap düğmesi; altında kategori sekmeleri
 * (ikonsuz, seçili turuncu alt çizgi; sığmazsa oklar). Telefonda burger çekmece: kategoriler, mağazalar, kanallar, hesap.
 */
export default function HeaderPremium() {
    const { pages, menuSettings } = React.useContext(MenuContext);
    const { logout, isAuth, severity } = React.useContext(AuthContext);
    const { setLoading } = React.useContext(LoadingContext);
    const [hesapAcik, setHesapAcik] = React.useState(false);
    const [magazaAcik, setMagazaAcik] = React.useState(false);
    const magazaRef = React.useRef(null);
    const [cekmece, setCekmece] = React.useState(false);
    const [sol, setSol] = React.useState(false);
    const [sag, setSag] = React.useState(false);
    const serit = React.useRef(null);
    const hesapRef = React.useRef(null);
    const location = useLocation();
    const yol = decodeURIComponent((location && location.pathname) || '').replace(/\/$/, '');

    // Eski Header'dan: sayfa açılınca / geri tuşuyla önbellekten gelince (bfcache) yükleniyor göstergesi kapanır
    React.useEffect(() => {
        const sayfaGosterildi = (e) => {
            if (e.persisted) {
                setLoading(false);
            }
        };
        window.addEventListener("pageshow", sayfaGosterildi);
        setLoading(false);
        return () => window.removeEventListener("pageshow", sayfaGosterildi);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // hesap / mağaza menüsü dışına tıklanınca / Esc ile kapanır
    React.useEffect(() => {
        if (!hesapAcik && !magazaAcik) return undefined;
        const disari = (e) => {
            if (hesapRef.current && !hesapRef.current.contains(e.target)) setHesapAcik(false);
            if (magazaRef.current && !magazaRef.current.contains(e.target)) setMagazaAcik(false);
        };
        const esc = (e) => { if (e.key === 'Escape') { setHesapAcik(false); setMagazaAcik(false); } };
        document.addEventListener('mousedown', disari);
        document.addEventListener('keydown', esc);
        return () => { document.removeEventListener('mousedown', disari); document.removeEventListener('keydown', esc); };
    }, [hesapAcik, magazaAcik]);

    const okDurumu = React.useCallback(() => {
        const s = serit.current;
        if (!s) return;
        setSol(s.scrollLeft > 4);
        setSag(s.scrollLeft + s.clientWidth < s.scrollWidth - 4);
    }, []);

    React.useEffect(() => {
        okDurumu();
        window.addEventListener('resize', okDurumu);
        return () => window.removeEventListener('resize', okDurumu);
    }, [okDurumu, pages]);

    const kaydir = (yon) => {
        const s = serit.current;
        if (s) s.scrollBy({ left: yon * Math.max(200, s.clientWidth * 0.6), behavior: 'smooth' });
    };

    const git = (to) => {
        setCekmece(false);
        setHesapAcik(false);
        setMagazaAcik(false);
        navigate(to);
    };

    const girisli = isAuth === 1;
    // admin sayfaları (auth'tan gelen C-Panel'ler dahil) kategori şeridinde değil, hesap menüsünde
    const kategoriSayfalari = pages.filter((p) => !String(p.to).startsWith(PATH_ADMIN));
    const hesapSecenekleri = [
        ...(girisli ? [
            { ad: 'Profilim', is: () => git('/profil/') },
            { ad: 'Alarmlarım ve favorilerim', is: () => git('/alarmlarim/') },
        ] : []),
        ...(girisli && severity === 1 ? [
            { ad: 'Admin paneli', is: () => git(PATH_ADMIN + '/'), grup: 'Yönetim' },
            { ad: 'Trendyol C-Panel', is: () => git(PATH_ADMIN + '/tcontrolpaneladmin'), grup: 'Yönetim' },
            { ad: 'Hepsiburada C-Panel', is: () => git(PATH_ADMIN + '/hcontrolpaneladmin'), grup: 'Yönetim' },
            { ad: 'Amazon C-Panel', is: () => git(PATH_ADMIN + '/acontrolpaneladmin'), grup: 'Yönetim' },
            { ad: 'Elektronik C-Panel', is: () => git(PATH_ADMIN + '/econtrolpaneladmin'), grup: 'Yönetim' },
            { ad: 'n11 C-Panel', is: () => git(PATH_ADMIN + '/ncontrolpaneladmin'), grup: 'Yönetim' },
            { ad: 'Pazarama C-Panel', is: () => git(PATH_ADMIN + '/pzcontrolpaneladmin'), grup: 'Yönetim' },
            { ad: 'İdefix C-Panel', is: () => git(PATH_ADMIN + '/ixcontrolpaneladmin'), grup: 'Yönetim' },
            { ad: 'Kod, kupon ve kampanya yönetimi', is: () => git(PATH_ADMIN + PATH_KODLAR_ADMIN), grup: 'Yönetim' },
            { ad: 'Reklam stüdyosu', is: () => git(PATH_ADMIN + PATH_REKLAM_STUDYOSU), grup: 'Yönetim' },
            { ad: 'Ürün eşleştirme', is: () => git(PATH_ADMIN + PATH_ESLESTIRME_ADMIN), grup: 'Yönetim' },
            { ad: 'Kategori eşleme', is: () => git(PATH_ADMIN + PATH_KATEGORI_ESLEME_ADMIN), grup: 'Yönetim' },
        ] : []),
        ...(menuSettings.includes('Çıkış Yap') || girisli
            ? [{ ad: 'Çıkış yap', is: () => { setHesapAcik(false); setCekmece(false); logout(); }, ayrac: true }]
            : [{ ad: 'Giriş yap', is: () => { girisOncesiniHatirla(); git('/login'); }, ayrac: true }]),
    ];
    const menuOgeleri = (Oge) => hesapSecenekleri.map((s, i) => {
        const onceki = hesapSecenekleri[i - 1];
        return (
            <React.Fragment key={s.ad}>
                {s.grup && (!onceki || onceki.grup !== s.grup) && <div className="iu-hesap-grup">{s.grup}</div>}
                {s.ayrac && <div className="iu-hesap-ayrac" />}
                <Oge s={s} />
            </React.Fragment>
        );
    });

    const aktifMi = (to) => yol === decodeURIComponent(to).replace(/\/$/, '');

    return (
        <header className="iu-header">
            <div className="iu-header-serit" aria-hidden="true" />
            <div className="iu-header-ust">
                <button type="button" className="iu-burger" onClick={() => setCekmece(true)} aria-label="Menü"><Cizgiler /></button>
                <a className="iu-logo" href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }} aria-label="İndirim Uzmanı ana sayfa">
                    <img src={logoImage} alt="İndirim Uzmanı" />
                </a>
                <div className="iu-ust-magazalar" ref={magazaRef}>
                    <button type="button" className={"iu-ust-menu-dugme" + (MAGAZALAR.some((m) => aktifMi(m.to)) ? " iu-ust-aktif" : "")}
                        onClick={() => setMagazaAcik(!magazaAcik)} aria-haspopup="menu" aria-expanded={magazaAcik}>
                        Mağazalar
                        <svg className={"iu-ust-ok" + (magazaAcik ? " iu-ust-ok-acik" : "")} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true"><path d="m6 9 6 6 6-6" /></svg>
                    </button>
                    {magazaAcik && (
                        <div className="iu-magaza-menu" role="menu">
                            {MAGAZALAR.map((m) => (
                                <a key={m.to} href={m.to} role="menuitem" className={"iu-magaza-oge" + (aktifMi(m.to) ? " iu-magaza-oge-aktif" : "")}
                                    onClick={(e) => { e.preventDefault(); git(m.to); }}>
                                    <span className="iu-magaza-logo"><img src={m.logo} alt={m.ad} className={m.sinif} /></span>
                                    <span className="iu-magaza-alt">{m.alt}</span>
                                </a>
                            ))}
                            <div className="iu-magaza-not">Yeni mağazalar yolda</div>
                        </div>
                    )}
                </div>
                <a href="/indirim-kodlari/" className={"iu-ust-menu-dugme iu-ust-kodlar" + (aktifMi('/indirim-kodlari') ? " iu-ust-aktif" : "")}
                    onClick={(e) => { e.preventDefault(); git('/indirim-kodlari/'); }}>Kodlar & Kuponlar</a>
                <div className="iu-header-sag">
                    <div className="iu-kanallar" aria-label="Kanallarımız">
                        {KANALLAR.map(({ ad, href, Ikon, sinif }) => (
                            <a key={ad} className={"iu-kanal-simge " + sinif} href={href} target="_blank" rel="noopener noreferrer" aria-label={ad} title={ad}>
                                <Ikon />
                            </a>
                        ))}
                    </div>
                    <div className="iu-hesap" ref={hesapRef}>
                        <button type="button" className={"iu-hesap-dugme" + (girisli ? " iu-hesap-girisli" : "")} onClick={() => setHesapAcik(!hesapAcik)}
                            aria-haspopup="menu" aria-expanded={hesapAcik} aria-label="Hesabım">
                            <KisiSimgesi />
                        </button>
                        {hesapAcik && (
                            <div className="iu-hesap-menu" role="menu">
                                <div className="iu-hesap-baslik">
                                    <b>{girisli ? 'Hoş geldin' : 'Hesabım'}</b>
                                    <span>{girisli ? 'Oturum açık' : 'Editör ve yönetici girişi'}</span>
                                </div>
                                {menuOgeleri(({ s }) => (
                                    <button type="button" role="menuitem" className="iu-hesap-oge" onClick={s.is}>{s.ad}<span aria-hidden="true">›</span></button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className={"iu-kategori-cerceve" + (sol ? " iu-sol-var" : "") + (sag ? " iu-sag-var" : "")
                + (kategoriSayfalari.some((p) => aktifMi(p.to)) ? "" : " iu-secili-yok")}>
                {sol && <button className="iu-ok iu-ok-sol" onClick={() => kaydir(-1)} aria-label="Sola kaydır"><ChevronLeftIcon /></button>}
                <nav className="iu-kategoriler" ref={serit} onScroll={okDurumu} aria-label="Kategoriler">
                    {kategoriSayfalari.map((sayfa) => (
                        <a key={sayfa.to} href={sayfa.to} className={"iu-cip" + (aktifMi(sayfa.to) ? " iu-cip-aktif" : "")}
                            onClick={(e) => { e.preventDefault(); git(sayfa.to); }}>
                            {sayfa.name}
                        </a>
                    ))}
                </nav>
                {sag && <button className="iu-ok iu-ok-sag" onClick={() => kaydir(1)} aria-label="Sağa kaydır"><ChevronRightIcon /></button>}
            </div>

            <Drawer anchor="left" open={cekmece} onClose={() => setCekmece(false)} PaperProps={{ className: "iu-cekmece" }}>
                <div className="iu-cekmece-ust">
                    <img src={logoImage} alt="İndirim Uzmanı" />
                    <button type="button" className="iu-cekmece-kapat" onClick={() => setCekmece(false)} aria-label="Kapat"><Cizgiler acik /></button>
                </div>

                <div className="iu-cekmece-baslik">Mağazalar</div>
                <div className="iu-cekmece-magazalar">
                    {MAGAZALAR.map((m) => (
                        <button key={m.to} type="button" className={"iu-cekmece-magaza" + (aktifMi(m.to) ? " iu-cekmece-aktif" : "")}
                            onClick={() => git(m.to)} aria-label={m.alt}>
                            <img src={m.logo} alt={m.ad} className={m.sinif} />
                        </button>
                    ))}
                </div>

                <button type="button" className={"iu-cekmece-kodlar" + (aktifMi('/indirim-kodlari') ? " iu-cekmece-aktif" : "")} onClick={() => git('/indirim-kodlari/')}>
                    <span aria-hidden="true">🎟️</span><span><b>Kodlar & Kuponlar</b><small>İndirim kodları, mağaza kuponları ve kampanyalar</small></span><span className="iu-cekmece-ok" aria-hidden="true">›</span>
                </button>

                <div className="iu-cekmece-baslik">Kategoriler</div>
                <div className="iu-cekmece-liste">
                    {kategoriSayfalari.map((sayfa) => (
                        <button key={sayfa.to} type="button" className={"iu-cekmece-oge" + (aktifMi(sayfa.to) ? " iu-cekmece-aktif" : "")} onClick={() => git(sayfa.to)}>
                            {sayfa.name}<span className="iu-cekmece-ok" aria-hidden="true">›</span>
                        </button>
                    ))}
                </div>

                <div className="iu-cekmece-kart">
                    <b>Fırsatları kaçırma</b>
                    <span>Yeni indirimler anında telefonuna gelsin.</span>
                    <div className="iu-cekmece-kanallar">
                        {KANALLAR.map(({ ad, href, Ikon, sinif }) => (
                            <a key={ad} className={"iu-cekmece-kanal " + sinif} href={href} target="_blank" rel="noopener noreferrer">
                                <Ikon fontSize="small" />{ad}
                            </a>
                        ))}
                    </div>
                </div>
            </Drawer>
        </header>
    );
}
